import { useCallback } from 'react';
import type { EventWithSource } from '../../../hooks';
import type { EventItem } from '../DeclinedEvents';

export const useCreateEventListItems = () =>
  useCallback(
    ({ events }: { events: EventWithSource[] }): EventItem[] =>
      events.map((event) => ({
        ...event,
        id: event.event.id,
        startTime: event.event.startTime,
      })),
    [],
  );
